import { render } from "./ImageObject.vue?vue&type=template&id=11a15a8d&scoped=true"
import script from "./ImageObject.vue?vue&type=script&lang=js"
export * from "./ImageObject.vue?vue&type=script&lang=js"

import "./ImageObject.vue?vue&type=style&index=0&id=11a15a8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a15a8d"]])

export default __exports__